import {Component, Input} from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'form-link',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgClass
  ],
  templateUrl: './form-link.component.html',
  styleUrl: './form-link.component.scss'
})
export class FormLinkComponent {
  @Input({ required: true }) subtitle!: string;
  @Input() value: string = '';
  @Input() danger: boolean = false;
  @Input() href: string = ''
  @Input() download: string = ''
}
